import React, {useContext} from 'react';
import {DeliveryPartnerCancelHistoryModal} from "./DeliveryPartnerCancelHistoryModal";
import {AppContext} from "../../../contexts/AppContext";

export function ModalController() {
    const {isCanceledHistoryDialogOpen, setIsCanceledHistoryDialogOpen, selectedOrder, setSelectedOrder} = useContext(AppContext)

    const onClose = () => {
        setIsCanceledHistoryDialogOpen(false)
        setSelectedOrder(null)
    }

    return (
        <>
            <DeliveryPartnerCancelHistoryModal
                isOpen={isCanceledHistoryDialogOpen}
                order={selectedOrder}
                onClose={onClose}/>
        </>
    );
}